const attrs = {
  links: [],
};

const options = {
  parentType: "campaigns",
  parentKey: "campaign_id",
};

const getters = {
  historyByCampaign: (state) => (campaign_id) => {
    return state.content
      .filter((entry) => entry.campaign_id === campaign_id)
      .sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });
  },
};

export default {
  generic: {
    attrs,
    options,
  },
  getters,
};
